export default __webpack_public_path__ + "static/media/Support-Scenario-Menu-B.6a8eb63b.png";